import './applied_published_filter_view.js.coffee'

class Monitoring.Views.SocialContents.Filters.AppliedPostPublishedFilterView extends Monitoring.Views.SocialContents.Filters.AppliedPublishedFilterView

  removeFilter: (value) ->
    @searchQuery.resetField('post_fb_is_published')

  getFilterValue: ->
    @searchQuery.get('post_fb_is_published')
